import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  TextField,
  Icon,
  Button,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import { coloresEmma, obtenerMisDatos } from "../../global/js/funciones";
import TareasTerminadas from "../general/TareasTerminadas";
import emma_w from "../../global/imagenes/emma_w.png";
import completado_img from "../../global/imagenes/proyecto_vida/completado.png";
import ProyectoVidaModal from "./ProyectoVidaModal";
import ProyectoVidaDetalle from "./ProyectoVidaDetalle";
import { SECCIONES, PROYECTO_VACIO } from "./helper";
import { obtenerProyecto, guardarProyecto, actualizarProyecto, obtenerVersiones } from "./services";
import { styles } from "./styles";

class ProyectoVida extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      vista: "formulario", // 'formulario' | 'detalle'
      // frase + las 6 secciones
      datos: { ...PROYECTO_VACIO },
      datosGuardados: { ...PROYECTO_VACIO }, // última versión persistida (para Cancelar)
      proyectoId: null,
      guardando: false,
      versiones: [],
      versionSeleccionada: "actual",
      programas: [],
      modalAbierto: false,
      seccionActiva: null, // objeto de SECCIONES
      modalListo: false,
    };
  }

  async componentDidMount() {
    let { mostrarModulo } = this.props;
    mostrarModulo({ ruta: "/mi_proyecto_de_vida", nombre: "Mi proyecto de vida" });
    // Programas del estudiante (para la vista de detalle)
    let programas = [];
    try {
      const misDatos = await obtenerMisDatos();
      programas = (misDatos && misDatos.programas) || [];
    } catch (e) {
      programas = [];
    }

    // Proyecto de vida vigente del estudiante
    let datos = { ...PROYECTO_VACIO };
    let vista = "formulario";
    let proyectoId = null;
    try {
      const { estado, resp } = await obtenerProyecto();
      if (estado === 200 && resp && resp.existe && resp.proyecto) {
        const p = resp.proyecto;
        proyectoId = p.id;
        Object.keys(PROYECTO_VACIO).forEach((k) => {
          datos[k] = p[k] || "";
        });
        // Si ya está completado, abre directamente en la vista de solo lectura.
        if (p.completado === "1") vista = "detalle";
      }
    } catch (e) {
      // Ante cualquier error, se queda con el formulario vacío.
    }

    this.setState({ cargando: false, programas, datos, datosGuardados: { ...datos }, vista, proyectoId }, () => {
      if (vista === "detalle") this.cargarVersiones();
    });
  }

  abrirModal = (seccion) => this.setState({ modalAbierto: true, seccionActiva: seccion });

  cerrarModal = () => this.setState({ modalAbierto: false, seccionActiva: null });

  guardarSeccion = (valor) => {
    let { seccionActiva, datos } = this.state;
    let { actualizarMensaje } = this.props;
    // El guardado por sección es solo local (en state.datos); todo se persiste
    // de una vez al presionar "Guardar" (POST/PUT a /proyecto).
    this.setState({
      datos: { ...datos, [seccionActiva.key]: valor },
      modalAbierto: false,
      seccionActiva: null,
    });
    actualizarMensaje({ titulo: "Apartado guardado", tipo: "success", mostrar: true, tiempo: 4000 });
  };

  cambiarFrase = ({ target }) => {
    this.setState({ datos: { ...this.state.datos, frase: target.value } });
  };

  guardarTodo = async () => {
    let { datos, proyectoId, guardando } = this.state;
    let { actualizarMensaje } = this.props;
    if (guardando) return;

    // Validar que la frase y las 6 secciones estén completas
    const faltantes = [];
    if (!datos.frase || !datos.frase.trim()) faltantes.push("Frase representativa");
    SECCIONES.forEach((s) => {
      if (!datos[s.key] || !datos[s.key].trim()) faltantes.push(s.titulo);
    });

    if (faltantes.length > 0) {
      actualizarMensaje({
        titulo: `Debes completar: ${faltantes.join(", ")}`,
        tipo: "info",
        mostrar: true,
        tiempo: 6000,
      });
      return;
    }

    // Payload: frase + las 6 secciones
    const payload = {};
    Object.keys(PROYECTO_VACIO).forEach((k) => {
      payload[k] = datos[k];
    });

    // POST si es la primera vez; PUT si ya existe el proyecto
    this.setState({ guardando: true });
    const { error, estado, resp } = proyectoId
      ? await actualizarProyecto(payload)
      : await guardarProyecto(payload);
    this.setState({ guardando: false });

    if (error) {
      actualizarMensaje({ titulo: "Ha ocurrido un error, intenta más tarde.", tipo: "error", mostrar: true, tiempo: 6000 });
      return;
    }

    if (estado === 200 || estado === 201) {
      const nuevoId = resp && resp.proyecto ? resp.proyecto.id : proyectoId;
      // Actualización idéntica: no hubo cambios -> pasa a detalle sin modal
      if (resp && resp.actualizado === false) {
        actualizarMensaje({ titulo: resp.titulo || "No se realizaron cambios.", tipo: "info", mostrar: true, tiempo: 5000 });
        this.setState({ vista: "detalle" }, this.cargarVersiones);
        return;
      }
      this.setState({ proyectoId: nuevoId, datosGuardados: { ...datos }, modalListo: true });
    } else {
      actualizarMensaje({
        titulo: (resp && resp.titulo) || "No se pudo guardar tu proyecto de vida.",
        tipo: "info",
        mostrar: true,
        tiempo: 6000,
      });
    }
  };

  cerrarModalListo = () => {
    // Al continuar, pasa a la vista de solo lectura (detalle) y carga versiones.
    this.setState({ modalListo: false, vista: "detalle" }, this.cargarVersiones);
  };

  editar = () => this.setState({ vista: "formulario", versionSeleccionada: "actual" });

  cancelar = () =>
    // Descarta los cambios no guardados y vuelve a la vista de detalle.
    this.setState({ datos: { ...this.state.datosGuardados }, vista: "detalle", versionSeleccionada: "actual" });

  cargarVersiones = async () => {
    try {
      const { estado, resp } = await obtenerVersiones();
      if (estado === 200 && resp && Array.isArray(resp.versiones)) {
        this.setState({ versiones: resp.versiones, versionSeleccionada: "actual" });
      }
    } catch (e) {
      // Si falla, el select cae al fallback con solo la "Versión actual".
    }
  };

  cambiarVersion = (id) => this.setState({ versionSeleccionada: id });

  estaCompletada = (key) => {
    const valor = this.state.datos[key];
    return valor && valor.trim().length > 0;
  };

  renderCard = (seccion) => {
    const { classes } = this.props;
    const completada = this.estaCompletada(seccion.key);
    return (
      <Grid item xs={12} sm={6} md={4} key={seccion.key}>
        <div
          onClick={() => this.abrirModal(seccion)}
          className={classes.formCard}
          style={{ backgroundImage: `url(${seccion.card})` }}
        >
          {/* Logo dentro de una burbuja + líneas decorativas */}
          <div className={classes.formCardLogoWrap}>
            <div className={classes.formCardBubble} style={{ border: `2px solid ${seccion.color}80` }}>
              <img src={seccion.logo} alt={seccion.titulo} style={{ width: 50, height: 50, objectFit: "contain" }} />
            </div>
            <img src={seccion.lines} alt="" className={classes.formCardLines} />
          </div>

          {/* Título + descripción */}
          <div style={{ flex: 1, paddingRight: 28 }}>
            <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#3a3a3a", lineHeight: 1.2 }}>
              {seccion.titulo}
            </Typography>
            <Typography variant="body2" style={{ color: "#5f5f5f", marginTop: 4 }}>
              {seccion.descripcionCard}
            </Typography>
          </div>

          {/* Flecha con el color de la sección */}
          <div className={classes.formCardFlecha} style={{ backgroundColor: seccion.color }}>
            <Icon style={{ color: "#fff", fontSize: 20 }}>arrow_forward</Icon>
          </div>

          {/* Indicador de completado */}
          {completada && (
            <div className={classes.formCardCheck}>
              <Icon style={{ color: "#fff", fontSize: 16 }}>check</Icon>
            </div>
          )}
        </div>
      </Grid>
    );
  };

  render() {
    const { classes, usuario } = this.props;
    let { cargando, vista, datos, programas, modalAbierto, seccionActiva, modalListo, guardando, versiones, versionSeleccionada, proyectoId } = this.state;
    const esActualizar = !!proyectoId;

    if (cargando) {
      return <TareasTerminadas mensaje="Cargando.." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />;
    }

    if (vista === "detalle") {
      // Opciones del select (actual + historial). Fallback si aún no cargan.
      const versionesOpciones = versiones.length
        ? versiones.map((v) => ({
            value: v.id,
            label: v.actual
              ? "Versión actual"
              : v.fecha
              ? moment(v.fecha).format("DD/MM/YYYY hh:mm a")
              : "Versión anterior",
          }))
        : [{ value: "actual", label: "Versión actual" }];
      // Datos de la versión seleccionada (la actual usa el state; el resto, su snapshot).
      const versionActiva = versiones.find((v) => String(v.id) === String(versionSeleccionada));
      const datosDetalle = versionActiva ? versionActiva.datos : datos;
      return (
        <ProyectoVidaDetalle
          datos={datosDetalle}
          usuario={usuario}
          programas={programas}
          versiones={versionesOpciones}
          versionSeleccionada={versionSeleccionada}
          onCambiarVersion={this.cambiarVersion}
          onEditar={this.editar}
        />
      );
    }

    return (
      <div style={{ padding: "24px 32px 60px 32px" }}>
        {/* Título y subtítulo */}
        <div className={classes.formTituloRow}>
          <span className={classes.formTituloBarra} />
          <Typography variant="h5" style={{ fontWeight: 700, color: "#2f2f2f" }}>
            Construye tu <span style={{ color: coloresEmma.primarycolor }}>perfil</span> personal y profesional
          </Typography>
        </div>
        <Typography variant="body2" style={{ color: "#6b6b6b", marginLeft: 15, marginBottom: 24 }}>
          Completa cada apartado para fortalecer tu plan de vida.
        </Typography>

        {/* Frase representativa (ancho completo) */}
        <div style={{ marginBottom: 24 }}>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            label="Frase que te represente"
            placeholder="Escribe aquí tu frase representativa..."
            value={datos.frase}
            onChange={this.cambiarFrase}
            inputProps={{ maxLength: 255 }}
          />
        </div>

        {/* Cards de las 6 secciones */}
        <Grid container spacing={3}>
          {SECCIONES.map((seccion) => this.renderCard(seccion))}
        </Grid>

        {/* Botones (parte inferior derecha) */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 32 }}>
          {esActualizar && (
            <Button variant="outlined" onClick={this.cancelar} className={classes.btnCancelar} disabled={guardando}>
              Cancelar
            </Button>
          )}
          <Button variant="contained" onClick={this.guardarTodo} className={classes.btnPrimario} disabled={guardando}>
            {guardando
              ? esActualizar ? "Actualizando..." : "Guardando..."
              : esActualizar ? "Actualizar" : "Guardar"}
          </Button>
        </div>

        {/* Modal de edición por sección */}
        <ProyectoVidaModal
          open={modalAbierto}
          seccion={seccionActiva}
          valorInicial={seccionActiva ? datos[seccionActiva.key] : ""}
          onGuardar={this.guardarSeccion}
          onCancelar={this.cerrarModal}
        />

        {/* Modal "¡Listo!" */}
        <Dialog open={modalListo} maxWidth="sm" fullWidth onClose={this.cerrarModalListo} PaperProps={{ style: { borderRadius: 16 } }}>
          <DialogContent style={{ textAlign: "center", padding: "36px 32px 40px 32px" }}>
            <img src={completado_img} alt="Listo" style={{ width: 120, height: 120, objectFit: "contain" }} />
            <Typography variant="h4" style={{ color: coloresEmma.primarycolor, fontWeight: 800, marginTop: 8 }}>
              ¡Listo!
            </Typography>
            <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#2f2f2f", marginTop: 8 }}>
              Has completado tu información de Proyecto de Vida
            </Typography>
            <Typography variant="body2" style={{ color: "#6b6b6b", marginTop: 10, lineHeight: 1.6 }}>
              Tu perfil personal y profesional ha sido actualizado correctamente. Recuerda que puedes volver a este
              espacio cuando quieras para consultar, complementar o actualizar tus respuestas.
            </Typography>
            <div className={classes.listoTip}>
              <Icon style={{ color: coloresEmma.secondarycolor }}>favorite_border</Icon>
              <Typography style={{ color: coloresEmma.secondarycolor, fontWeight: 700, fontSize: "0.9rem" }}>
                ¡Cada respuesta es un paso más hacia la vida que quieres construir!
              </Typography>
            </div>
            <Button
              variant="contained"
              onClick={this.cerrarModalListo}
              className={classes.btnPrimario}
              style={{ marginTop: 24 }}
            >
              Continuar
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return { usuario };
};

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProyectoVida));
